import { c as _c } from "react/compiler-runtime";
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';
export const ByovSetupMethod = t0 => {
  const $ = _c(8);
  const {
    method,
    onChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "16px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onChange) {
    t2 = (_, value) => {
      if (value === "console" || value === "script") {
        onChange(value);
      }
    };
    $[1] = onChange;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ToggleButton value="console">AWS Console</ToggleButton>;
    t4 = <ToggleButton value="script">AWS CLI script</ToggleButton>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== method || $[6] !== t2) {
    t5 = <Stack direction="row" sx={t1}><ToggleButtonGroup exclusive={true} value={method} aria-label="Bucket setup method" onChange={t2}>{t3}{t4}</ToggleButtonGroup></Stack>;
    $[5] = method;
    $[6] = t2;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};